import React, { useContext, useState } from 'react';
import { useDomPath } from '@thd-olt-functional/utils';
import { Col } from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { CheckAvailabilityContext } from '../CheckAvailabilityContext';
import { InputForm } from './subcomponents/inputForm/InputForm';
import { AvailabilityMessage } from './subcomponents/depotDirectResponse/AvailabilityMessage';
import '../styles/depot-direct-service.scss';

export const DepotDirectService = () => {
  const {
    defaultMessaging,
    hideInput: hideInputComponentAltogether,
    checkAvailabilityModel
  } = useContext(CheckAvailabilityContext);

  const [domPath, ref] = useDomPath();
  const [showInput, setShowInput] = useState(!checkAvailabilityModel);
  const { isConsumerApp } = useContext(ExperienceContext);

  const onSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }
    // This form submission is intentionally a no-op as the underlying
    // data fetching mechanism via axios has been removed as obsolete.
  };

  // The loading spinner logic is removed as the component no longer fetches data.

  if (hideInputComponentAltogether && defaultMessaging && checkAvailabilityModel) {
    return (
      <Col aria-live="polite" aria-busy="false" nopadding>
        <AvailabilityMessage availabilityData={checkAvailabilityModel} />
      </Col>
    );
  }

  return (
    <div aria-live="polite" aria-busy="false" className="depot-direct-service" ref={ref}>
      {!hideInputComponentAltogether
      && showInput
      && (
        <InputForm onSubmit={onSubmit} />
      )}
      { !showInput
      && (
        <Col nopadding>
          { defaultMessaging
          && checkAvailabilityModel
          && (
            <Col nopadding>
              <AvailabilityMessage availabilityData={checkAvailabilityModel} />
            </Col>
          )}
          {!isConsumerApp
          && (
            <Col nopadding>
              <button
                type="button"
                className="u__default-link"
                onClick={() => setShowInput(true)}
              >
                Change Delivery Zip Code
              </button>
            </Col>
          )}
        </Col>

      )}
    </div>
  );
};